/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Regulations model module.
 * @module model/Regulations
 * @version 1.0.0
 */
class Regulations {
    /**
     * Constructs a new <code>Regulations</code>.
     * @alias module:model/Regulations
     */
    constructor() { 
        
        Regulations.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Regulations</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Regulations} obj Optional instance to populate.
     * @return {module:model/Regulations} The populated <code>Regulations</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Regulations();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('link')) {
                obj['link'] = ApiClient.convertToType(data['link'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Label of the regulation
 * @member {String} name
 */
Regulations.prototype['name'] = undefined;

/**
 * Url of the regulation
 * @member {String} link
 */
Regulations.prototype['link'] = undefined;






export default Regulations;

